import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { InteractionType, LocalService, PageKey, Status, Wrappers5 } from '../../../service/local.service';
import { MenuManagementService } from '../../../service/menu-management.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  wrapper: Wrappers5; config = {}; isIncRead: boolean = true; businessId = ''; interactionType = 0; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private menuManagementService: MenuManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.NotificationsBusiness, this.businessId);
      else
        this.configurationManagementService.ensurePageActions(PageKey.Notifications);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.menuManagementService.getNotifications(this.businessId, false, this.isIncRead, this.wrapper ? this.wrapper.paging : null, true).subscribe(result => {
      this.wrapper = result.wrapper;
    });
  }
}
